import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tt-root" }

import { inject, ref, provide, watch, onUnmounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    open: { type: Boolean, default: undefined },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const globalCfg = inject<any>('tooltipGlobalConfig', { openDelay: 0, closeDelay: 0, disabled: false })
const isOpen = ref(false)
const triggerEl = ref<HTMLElement | null>(null)
let timer: number | undefined

function show() {
  if (props.disabled || globalCfg.disabled) return
  clearTimeout(timer)
  timer = window.setTimeout(() => { 
    isOpen.value = true 
  }, globalCfg.openDelay)
}

function hide(immediate = false) {
  clearTimeout(timer)
  if (immediate) {
    isOpen.value = false
  } else {
    timer = window.setTimeout(() => { 
      isOpen.value = false 
    }, globalCfg.closeDelay)
  }
}

// Only update if open prop is explicitly provided
watch(() => props.open, (newVal) => {
  if (newVal !== undefined) {
    clearTimeout(timer)
    isOpen.value = !!newVal
  }
}, { immediate: true })

// Cleanup on unmount
onUnmounted(() => {
  clearTimeout(timer)
})

// Create unique ID for each tooltip instance
const tooltipId = `tt-${Math.random().toString(36).slice(2, 11)}`

provide('tooltipCtx', {
  isOpen,
  show,
  hide,
  id: tooltipId,
  triggerEl
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})